module.exports = __webpack_public_path__ + "img/2600f.2d5bf2d5.png";